import React, { useContext } from 'react';

import { Button, Space, Typography } from 'antd';
import { ApplicationUIContext, Drawer, useDrawerState, SummaryGrid } from '@yuhuinc/ui-library';
import { CardSectionTitle } from '../../common/Styles';
import { getTranslatedString } from 'helpers/i18n';
import AddInsurance from './AddInsurance';
import { phaseTwoWip } from '../../common/actions/WipModal';
import { featureEnabled } from 'helpers/ToggleBot';

const { Link } = Typography;

const DUMMY_DATA = [
  [
    getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.policyProvider'
    ),
    'Sonnet Insurance',
  ],
  [
    getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.policyNumber'
    ),
    '968772301172-JB',
  ],
  [
    getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.validFrom'
    ),
    '2022-04-01',
  ],
  [
    getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.validTo'
    ),
    '2023-03-31',
  ],
  [
    getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.primaryInsured'
    ),
    'Geraldine Blanchard',
  ],
  [
    getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.otherInsured'
    ),
    '',
  ],
  [
    getTranslatedString(
      'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.proof'
    ),
    <Link>filename.png</Link>,
  ],
];

const Insurance = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [, addInsurance] = useDrawerState(false);

  const onAddInsurance = () => {
    addInsurance.close();
  };

  return (
    <Space direction="vertical" size="middle">
      <CardSectionTitle>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.insurance'
        )}
      </CardSectionTitle>
      {!featureEnabled('4-0-phase-2-wip') && <SummaryGrid values={DUMMY_DATA} />}
      <Button
        size={isMobile && 'large'}
        onClick={() => {
          phaseTwoWip(addInsurance.open);
        }}
      >
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.addInsurance'
        )}
      </Button>
      <Drawer
        title={getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.applicants.insurance.drawerTitle'
        )}
        visible={addInsurance.isVisible}
        closable
        destroyOnClose
        onClose={addInsurance.close}
      >
        <AddInsurance onSubmit={onAddInsurance} onCancel={addInsurance.close} />
      </Drawer>
    </Space>
  );
};

export default Insurance;
